<ng-container *ifScreenSize="screenType.Desktop">
  <div class="banner" role="banner">
    <h1>{{ 'challenges.page.title' | translate }}</h1>
  </div>
</ng-container>

<ng-container *ifScreenSize="screenType.Mobile">
  <fgb-barcode></fgb-barcode>
</ng-container>

<div class="container mt-lg-4 mt-3">
  <fgbcl-badge-achieved></fgbcl-badge-achieved>
</div>

<div class="mt-5">
  <fgbcl-scorecard-list-view
    [icon]="'chevron_right'"
    [showPlaceholder]="true"
    [isSponsorInBody]="false"
  ></fgbcl-scorecard-list-view>
</div>
